import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import store from './store';
import './plugins/tiptap-vuetify';
import './plugins/dateTimePicker';
import './plugins/vImage';
import './plugins/googleMaps';
import './plugins/cookies';
import './plugins/facebookPixel';

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: h => h(App),
  store,
}).$mount('#app');